import { WildNavigationType } from "../../../../../../data/enums/navigation_type";
import { FeaturesComponentListData } from "../../FeaturesData";

export const communicationsListData: FeaturesComponentListData = {
  image: "https://firebasestorage.googleapis.com/v0/b/wild-live.appspot.com/o/v2%2Fimagesforbrochuresite%2Fcommunications%2Freminder-on-phone.png?alt=media&token=44904631-b046-4eec-9850-0d82a3e03a03",
  title: "Communications",
  subtitle: "It's all Taken Care Of",
  page: WildNavigationType.COMMUNICATIONS,
}